__turbopack_context__.v({
  "avatar-main": "testimonial-module-scss-module__jExCja__avatar-main",
  "quote-circle": "testimonial-module-scss-module__jExCja__quote-circle",
  "testimonial-author": "testimonial-module-scss-module__jExCja__testimonial-author",
  "testimonial-author-icons": "testimonial-module-scss-module__jExCja__testimonial-author-icons",
  "testimonial-container": "testimonial-module-scss-module__jExCja__testimonial-container",
  "testimonial-description": "testimonial-module-scss-module__jExCja__testimonial-description",
  "testimonial-full-height": "testimonial-module-scss-module__jExCja__testimonial-full-height",
});
